var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7717 5C18.3662 5 18.8486 4.552 18.8486 4C18.8486 3.44799 18.3662 2.99999 17.7717 2.99999L9.15631 2.99999C8.56185 2.99999 8.07939 3.448 8.07939 4C8.07939 4.552 8.56185 5 9.15631 5L17.7717 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4777 21C13.7534 21 14.0075 20.914 14.2186 20.719C15.2955 19.719 21.756 13.719 22.834 12.719C23.5114 12.089 23.0526 11 22.0931 11L18.8623 11L18.8623 7.99996C18.8623 7.44796 18.3798 6.99995 17.7854 6.99995L9.16997 6.99996C8.57551 6.99996 8.09305 7.44796 8.09305 7.99996L8.09305 11L4.86227 11C3.90273 11 3.40951 12.089 4.08797 12.719L12.7034 20.719C12.9144 20.914 13.202 21 13.4777 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDown);
export default __webpack_public_path__ + "static/media/white-down.2cc888f84310f9b8d42d366fba8d2c49.svg";
export { ForwardRef as ReactComponent };